const AUTH_URL = '/userpolicy';

export default {
  // 通用api
  common: {
    // 登录
    login: AUTH_URL + '/userpolicy/auth/v1/login',
    // 应用列表（临时）
    appList: AUTH_URL + '/userpolicy/sys/v1/list',
    // 校验token是否有效
    checkToken: AUTH_URL + '/userpolicy/auth/v1/check_token',
    // 修改密码
    changePwd: AUTH_URL + '/userpolicy/auth/v1/update_password',
    loginout: AUTH_URL + '/userpolicy/auth/v1/log_out',
    menuList: AUTH_URL + '/userpolicy/auth/v1/user_systems',
    getUserByTokenId: AUTH_URL + '/userpolicy/auth/v1/sign_on',
    getVerifyCode: AUTH_URL + '/userpolicy/auth/v1/get_verify_code',
    // 发送短信验证码
    senMessageCode: AUTH_URL + '/open/user/v1/get_verify_code',
    getZhuyunConfig: '/userpolicy/open/bam/v1/config',
  },
};



// WEBPACK FOOTER //
// ./src/utils/api.js